import React, { useEffect, useState } from "react";
import { Layout } from "antd";
import "../SellerResponsive.css";
import "./SellerLayout.css";
import { Helmet } from "react-helmet";
import NavbarBlank from "../components/SellerComponents/SellerHeader/NavbarBlank";

const { Header: AntHeader } = Layout;
const DESKTOP_BREAKPOINT = 992;

export const SellerBlankLayout = (props) => {
  const isMobileViewport =
    typeof window !== "undefined" && window.innerWidth < DESKTOP_BREAKPOINT;

  const [collapsed, setCollapsed] = useState(() => {
    const storedCollapsed = localStorage.getItem("collapsed");
    return storedCollapsed !== null ? JSON.parse(storedCollapsed) : isMobileViewport;
  });

  useEffect(() => {
    localStorage.setItem("collapsed", JSON.stringify(collapsed));
  }, [collapsed]);

  useEffect(() => {
    const syncSidebarWithViewport = () => {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        setCollapsed(false);
      } else {
        setCollapsed(true);
      }
    };

    syncSidebarWithViewport();
    window.addEventListener("resize", syncSidebarWithViewport);
    return () => window.removeEventListener("resize", syncSidebarWithViewport);
  }, []);

  return (
    <Layout
      className={`layout-dashboard layout-profile seller-layout-root seller-layout-no-sidebar ${collapsed ? "menu-collapsed" : ""}`}
      style={{ height: "100vh", overflow: "hidden" }}
    >
      <Helmet>
        <title>MOB - Seller Portal</title>
      </Helmet>

      <AntHeader className="seller-layout-header">
        <NavbarBlank collapsed={collapsed} setCollapsed={setCollapsed} />
      </AntHeader>

      <Layout style={{ flex: 1, overflow: "hidden", minHeight: 0 }}>
        <section style={{ overflow: "auto", flex: 1, minHeight: 0 }} className="content-ant seller-layout-content">
          {props.children}
        </section>
      </Layout>
    </Layout>
  );
};

export default SellerBlankLayout;
